import * as React from "react";
import {cx} from "emotion";

import "./listing-type.scss";

import {cs}     from "@Common/react/chain-services";
import {Select} from "@Common/ui-components/heavy/common/design2/select/select";

// ["mailing", "shipping", "pickup"]
export const ListingType = ({ className, listingTypeLabel, listingTypeOptions, calSelected, state}) => cs(
    ({}) => (
        <div className={cx("listing-type-j8u", className)}>
            <div className="header">
                <div className="title">{listingTypeLabel}</div>
            </div>
            {listingTypeOptions.length === 1 ? (
                <div className="value" xd-qa-type="text_field" xd-qa-name={listingTypeLabel}>
                    {listingTypeOptions[0]}
                </div>
            ) : (
                <div className="card">
                    <div className="select">
                        {Select({
                            list: listingTypeOptions || [],
                            itemToLabel: (o) => o,
                            isSelected: (o) => o == calSelected,
                            onChange: (o) => state.onChange(o ?? null),
                            forcedExpandLeft: true,
                            xdQaName: listingTypeLabel,
                        })}
                    </div>
                </div>
            )}
        </div>
    )
);
